import { render, staticRenderFns } from "./DataCorrectionDetailsMessages.vue?vue&type=template&id=a7ea5034&scoped=true&"
import script from "./DataCorrectionDetailsMessages.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionDetailsMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ea5034",
  null
  
)

export default component.exports